export default __webpack_public_path__ + "assets/images/3da931b0814a309d334e5e79a818cdc4.svg";